export function removeDots(valor) {
  return valor && valor.replace(/[^\d]/g, "");
}